import { Metadata } from '../../entities/metadata';
import { MetadataProcessorInterface } from '../../interfaces/components/processor/metadata/metadata-processor.interface';
import { Injectable, MultiInject } from '../dependency-injection/decorators';

@Injectable()
export class MetadataResolver {
  public constructor (@MultiInject('MetadataProcessor') private readonly processors: MetadataProcessorInterface[]) {
  }

  public async resolve (): Promise<Metadata> {
    const metadata = new Metadata();

    for (const processor of this.processors) {
      await processor.process(metadata);
    }

    return metadata;
  }
}
